import React from "react";
import * as styles from "./FooterCopyLine.module.scss";
function FooterCopyLine() {
  return (
    <div className={styles.root}>
      <span className={styles.copyContent}>&copy;&nbsp;Fibery Limited</span>
      <a href="/terms" className={styles.copyMenuItem}>
        Terms
      </a>
      <a href="/privacy-policy" className={styles.copyMenuItem}>
        Privacy Policy
      </a>
      <a href="/cookies-policy" className={styles.copyMenuItem}>
        Cookies Policy
      </a>
      <a href="/cloud-security" className={styles.copyMenuItem}>
        Cloud Security
      </a>
    </div>
  );
}

export default FooterCopyLine;
